module.exports = __webpack_public_path__ + "static/media/logo-markdown.ae7fedcb.svg";